export default __webpack_public_path__ + "static/media/603.ac33e6ff.png";